import React, { useCallback } from "react";
import { Input } from "@treelab/panda";

import { IFilterValue } from "../../../../../../types/form-type";

import { Container } from "./styled";

interface IProps {
  name: string;
  value: IFilterValue;
  onChange: (value: { [key: string]: any }) => void;
}

const Checkbox: React.FC<IProps> = ({ name, value, onChange }) => {
  const { filterString } = value;

  const handleChange = useCallback(
    (data: boolean) => {
      onChange({ filterString: data });
    },
    [onChange]
  );

  return (
    <Container>
      <Input.Checkbox
        input={{
          name: `${name}.filterString`,
          value: filterString,
          onChange: handleChange,
        }}
        meta={{}}
      />
    </Container>
  );
};

export default Checkbox;
